import React from 'react';

const variants = {
  primary: {
    background: 'var(--color-accent)',
    color: '#fff',
    border: 'none',
  },
  secondary: {
    background: '#fff',
    color: 'var(--color-accent)',
    border: '1.5px solid var(--color-accent)',
  },
  danger: {
    background: 'var(--color-danger)',
    color: '#fff',
    border: 'none',
  },
  ghost: {
    background: 'transparent',
    color: 'var(--color-text)',
    border: '1.5px solid var(--color-border)',
  },
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  disabled = false,
  onClick,
  type = 'button',
  style = {},
  ...props
}) {
  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.375rem',
    borderRadius: 'var(--radius-sm)',
    fontWeight: 600,
    fontSize: size === 'sm' ? '0.9375rem' : '1rem',
    padding: size === 'sm' ? '0 0.875rem' : '0 1.25rem',
    minHeight: size === 'sm' ? '52px' : '52px',
    width: fullWidth ? '100%' : undefined,
    opacity: disabled ? 0.55 : 1,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'opacity .15s, transform .1s',
    ...variants[variant],
    ...style,
  };

  return (
    <button
      type={type}
      style={base}
      disabled={disabled}
      onClick={onClick}
      onMouseDown={(e) => { if (!disabled) e.currentTarget.style.transform = 'scale(0.97)'; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = ''; }}
      {...props}
    >
      {children}
    </button>
  );
}
